import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { OptionalAdditionalStyle } from '../components.utils';

export interface AdDataProps {
  id: string | null
}
type AdProps = AdDataProps & OptionalAdditionalStyle;

const createStyle = () => StyleSheet.create({
  ad: {
    display: 'flex',
    justifyContent: 'center',
  },
});
export const Ad:React.FunctionComponent<AdProps> = React.memo(({ id, additionalStyle }) => {
  const style = createStyle();
  return id ? <div id={id} className={additionalStyle ? css(style.ad, additionalStyle.style) : css(style.ad)} /> : null;
});
